import { useQuery } from "@tanstack/react-query";
import { Card, Col, Row } from "react-bootstrap"
import { getRequest } from "../../../../utils/apiRequest";
import { Loader } from "../../../../components/loader";
import { formatDateTimeToDDMMYYYY } from "../../../../utils/formatDateTime";

export const UserInvoices = ({user, token}) => {

    const userInvoices = useQuery({
        queryKey: ["user-invoides"],
        queryFn: () => getRequest(`/auth/invoice/${user.id}`, token),
    });
    const { data } = userInvoices;

    return (
        <Loader isActive={userInvoices.isLoading || userInvoices.isFetching}>
            {data &&
                <Card className="mt-3">
                    <Card.Header>
                        <Row>
                            <Col xs={6}>
                                Rechnungen
                            </Col>
                        </Row>
                    </Card.Header>
                    <Card.Body className="no-border-on-last-child p-0 overflow-hidden">
                        {data.length > 0 &&
                            (data.map((invoice) => (
                                <Row key={invoice.id} className="border-bottom border-1 p-3">
                                    <Col xs={6}>
                                        {formatDateTimeToDDMMYYYY(invoice.date)}
                                    </Col>
                                    <Col xs={6} className="text-end">
                                        Nr. {invoice.number}
                                    </Col>
                                </Row>
                            )))
                        }
                        {data.length === 0 &&
                            <Row className="border-bottom border-1 p-3">
                                <Col xs={12}>
                                    Keine Rechnungen gefunden.
                                </Col>
                            </Row>
                        }
                    </Card.Body>
                </Card>
    }
        </Loader>
    )
}